// extracted by mini-css-extract-plugin
export default {"list":"DrawerNav_list__yNVkP","listItem":"DrawerNav_listItem__1xU9e"};